import { render, staticRenderFns } from "./Measurements.vue?vue&type=template&id=3ad18df2&scoped=true&"
import script from "./Measurements.vue?vue&type=script&lang=ts&"
export * from "./Measurements.vue?vue&type=script&lang=ts&"
import style0 from "./Measurements.vue?vue&type=style&index=0&id=3ad18df2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad18df2",
  null
  
)

export default component.exports